export default {"src":"/_next/static/media/aiPost.5760136a.svg","height":533,"width":631,"blurWidth":0,"blurHeight":0};